import React, { useState } from "react";

const InputImage = ({ onChange, label, name, value, errors = [], ...props }) => {
    const [base64Image, setBase64Image] = useState(value);
    const [fileError, setFileError] = useState("");

    const hasError = errors[props.name] ? "is-invalid" : "";
    const hasFileError = fileError ? "is-invalid" : "";

    const ErrorDialog = () => {
        return errors[props.name] ? (
            <div className="invalid-feedback">
                {errors[props.name][0]}
            </div>
        ) : null;
    };

    const FileErrorDialog = () => {
        return fileError ? (
            <div className="invalid-feedback">
                {fileError}
            </div>
        ) : null;
    };

    const serializeOnChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
            if (!allowedExtensions.exec(file.name)) {
                setFileError("Formato de arquivo não suportado. Por favor, selecione uma imagem com extensão .jpg, .jpeg, .png ou .gif.");
                return;
            }

            setFileError("");
            onChange(file);
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div>
                        <label className="form-label">{label}</label>
                    </div>
                    <input
                        className={`form-control ${hasError} ${hasFileError}`}
                        type="file"
                        name="myImage"
                        onChange={serializeOnChange}
                        {...props}
                    />
                    <ErrorDialog />
                    <FileErrorDialog />
                </div>
            </div>

            <div className="row mt-2">
                <div className="col-12">
                    {value && <img src={value} alt="Selected image" className="img-fluid rounded" style={{ maxHeight: '50vh' }} />}
                </div>
            </div>
        </>
    );
};

export default InputImage;